import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { CompanyForm } from "@/components/companies/CompanyForm";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

const Companies = () => {
  const { data: businessTypes, isLoading } = useQuery({
    queryKey: ["businessTypes"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("business_types")
        .select("*")
        .order("name");

      if (error) {
        toast.error("Erreur lors du chargement des types d'entreprise");
        throw error;
      }

      return data;
    },
  });

  return (
    <DashboardLayout userType="admin">
      <CompanyForm 
        businessTypes={businessTypes || []}
        onSuccess={() => {
          toast.success("Entreprise créée avec succès");
        }}
      />
    </DashboardLayout>
  );
};

export default Companies;